import { SOCIAL_PLATFORMS } from '~/constants';

export type IPlatform = keyof typeof SOCIAL_PLATFORMS;

export enum IPlatformContent {
  post = 'post',
  story = 'story',
  tiktok = 'tiktok',
  youtube = 'youtube',
}

export type PlatformContentType = keyof typeof IPlatformContent;
